module.exports = __webpack_public_path__ + "static/media/test16_2.841ee920.png";